<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <CRow>
                <span class="custom-header-profile">
                  <img src="../assets/img/Maskgroup.svg"
                /></span>

                <span class="custom-user-title"> {{ NickName }}</span>
                <span class="custom-sub-grade"> {{ Grade }}</span>
            </CRow>
            <h4 style="color: #000; text-align: left" class="custom-user-grade">
              Select the exam you going to sit this year
            </h4>
            <br />
            <div class="ml-3 mr-3">
              <div v-if="user.countryId > 0 && user.countryId != 13">
                <v-select
              horizontal
              v-model="SelectedExam"
              :options="examcountry"
              label="examName"
              placeholder="Select Exam"
              @input="GoToSubject"
            />
              </div>
              <div v-else-if="user.countryId == 13">
                <v-select
              horizontal
              v-model="SelectedExam"
              :options="exam"
              label="examName"
              placeholder="Select Exam"
              @input="GoToSubject"
            /></div>
              <div v-else>
                <v-select
              horizontal
              v-model="SelectedExam"
              :options="exam"
              label="examName"
              placeholder="Select Exam"
              @input="GoToSubject"
            />
              </div>

             
            </div>
            <!-- <form class="ml-3 mr-3">
              <input
                type="text"
                class="custom-input-user"
                placeholder="Search Exam"
                 v-model.lazy="SearchQuery"
                @change="ApplyFilter()"
              />
              <img src="../assets/img/icon/iconContainer.svg" />
            </form>

            <div class="list-grade">
             <CCol sm="12" v-for="item in FilterExam" v-bind:key="item.id">
                  <div class="ml-3">
                                <input
                                  type="radio"
                                  id="item.id"
                                  :value="item.examName"
                                  v-model="SelectedExam"
                                  class="mr-2 ml-2"
                                 @change="GoToUploadImage(item.id)"
                                 
                                />
                              <label for="item.id">  {{ item.examName }}</label>
                  </div>
                  <div style="clear: both"></div>
                  <hr />
                </CCol>
            </div> -->
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>
    <div class="header-top">Register Student</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
Vue.use(VuejsDialog);

export default {
  components: {
    MainlayoutBottom,
  },
  data: function () {
    return {
      Grade: this.$route.query.Grade,
      NickName: this.$route.query.NickName,
      SelectedExam: "",
      exam: [],
      examcountry: [],
      FilterExam: [],
      SearchQuery: "",
      user: {}
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.GetExamBycountry();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
   
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetExam(this.user.id);
            this.GetExamBycountry(this.user.id);
          }
        });
    },
    GetExam() {
      this.$API
        .get(this.$ExamListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.exam = response.data;
            this.FilterExam = this.exam;
          }
        });
    },
    GetExamBycountry() {
      this.$API
        .get(this.$GetExamCountry + "?countryId=" + this.user.countryId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.examcountry = response.data;
            this.FilterExam = this.exam;
          }
        });
    },
    // GoToUploadImage(id) {
    //   this.$router.push(
    //     "/UploadImageParent?NickName=" +
    //       this.$route.query.NickName +
    //       "&Grade=" +
    //        this.$route.query.Grade + 
    //       "&Exam=" +
    //        this.SelectedExam + "&ExamId=" +
    //        id
    //   );
    // },
    GoToSubject(){
      this.$router.push(
        "/RegisterStudentParentSubject?NickName=" +
          this.$route.query.NickName +
          "&Grade=" +
           this.$route.query.Grade + 
          "&Exam=" +
           this.SelectedExam.id
      );
    },
     GoBack() {
     this.$router.back();
    },
     ApplyFilter: function () {
      var arr = _.orderBy(this.exam, ["examName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(
          arr,
          ({ examName }) =>
            _.some([
              _.includes(!examName || examName.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
            ])
        );
        this.FilterExam = result;
      }
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}


</style>